export default __webpack_public_path__ + "static/media/flagged-for-review.67f6c050.svg";